import type {
  AssignData,
  Create2Data,
  GetAssignedWorksheetsData,
  ScoreData,
  SliceCreverseEntranceWorksheetResponse,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'
import { mapSliceContent, type Slice, sliceSchema } from '~/schema/slice'

import {
  type EntranceWorksheet,
  type EntranceWorksheetAssignEcho,
  EntranceWorksheetAssignEchoSchema,
  type EntranceWorksheetCreation,
  EntranceWorksheetCreationSchema,
  EntranceWorksheetSchema,
  type GuestEntranceScoringResult,
  GuestEntranceScoringResultSchema,
  type GuestEntranceWorksheet,
  GuestEntranceWorksheetSchema,
} from './schemas'

const ENTITY = 'EntranceWorksheet'

export const adaptEntranceWorksheets = (
  raw: SliceCreverseEntranceWorksheetResponse,
): Slice<EntranceWorksheet> =>
  mapSliceContent(
    parseApiResponse(sliceSchema(EntranceWorksheetSchema), raw, ENTITY),
    (worksheet) => worksheet,
  )

export const adaptEntranceWorksheetCreation = (raw: Create2Data): EntranceWorksheetCreation =>
  parseApiResponse(EntranceWorksheetCreationSchema, raw, ENTITY)

export const adaptEntranceWorksheetAssignEcho = (raw: AssignData): EntranceWorksheetAssignEcho =>
  parseApiResponse(EntranceWorksheetAssignEchoSchema, raw, ENTITY)

export const adaptGuestEntranceWorksheets = (
  raw: GetAssignedWorksheetsData,
): Slice<GuestEntranceWorksheet> =>
  mapSliceContent(
    parseApiResponse(sliceSchema(GuestEntranceWorksheetSchema), raw, ENTITY),
    (worksheet) => worksheet,
  )

export const adaptGuestEntranceScoringResult = (raw: ScoreData): GuestEntranceScoringResult =>
  parseApiResponse(GuestEntranceScoringResultSchema, raw, ENTITY)
